<template>
  <div class="colorDominant" style="border-radius: 6px 6px 0 0">
    <v-alert dense prominent text type="error" class="ma-2">
      {{ warningMsg }}
    </v-alert>

    <v-tabs
      v-model="tab"
      center-active
      show-arrows
      background-color="colorDominant colorTabs"
    >
      <v-tab v-for="(item, i) in items" :key="`${i}-${item.sport}`">
        {{ item.sport }}
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab" class="colorDominant" light>
      <v-tab-item v-for="(item, i) in items" :key="`${item.sport}-${i}`">
        <div
          v-if="item.warning"
          class="px-4 pb-2 warning--text"
          style="white-space: pre-line"
        >
          {{ item.warning }}
        </div>
        <div class="px-4 pb-2 info--text">
          {{ `${$t("updatedAt")} ${updatedDate} ${updatedTime}` }}
        </div>

        <v-expansion-panels light focusable>
          <v-expansion-panel
            v-for="(item, i) in item.markets"
            :key="`${i}-${item.market}`"
          >
            <v-expansion-panel-header>{{
              item.market
            }}</v-expansion-panel-header>
            <v-expansion-panel-content class="pt-4">
              <div
                v-for="(item, i) in item.outcomes"
                :key="`${i}-${item.outcomes}`"
                class="mb-2"
              >
                <strong>{{ item.outcome }}</strong> {{ item.obs }}
                {{ item.description }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
export default {
  name: "RulesBet",
  data: () => ({
    tab: null,
    items: "",
    warningMsg: "",
    updatedDate: "",
    updatedTime: "",
  }),
  mounted() {
    const lang = localStorage.getItem("language");
    const url = `https://dozr8la71aog.cloudfront.net/rules/rules_${lang}.json`;

    this.$axios.get(url).then((resp) => {
      this.warningMsg = resp.data.warning;
      this.items = resp.data.sports;
      const updatedAt = new Date(resp.headers["last-modified"]);
      this.updatedDate = updatedAt.toLocaleString(lang, { dateStyle: "long" });
      this.updatedTime = updatedAt.toLocaleTimeString(lang);
    });
  },
  methods: {},
};
</script>
